<template>
  <div class="diadoc_object_links card" v-if="Object.keys(diadoc_object_links).length > 0">
<!--    <div class="diadoc_object_links__header">-->
<!--      Diadoc Docs-->
<!--    </div>-->

    <div class="diadoc_object_links__docs">
      <router-link
          v-for="(file, key) in diadoc_object_links"
          :key="key"
          :to="'/diadoc_document/' + file.id"
          class="doc link"
          :title="title_file(file)"
      >
        <span class="mdi mdi-file-document-outline" />
        <p class="file_name" v-html="short_file_name(file.file_name)"/>
      </router-link>
    </div>

  </div>

<!--  </div>-->
</template>

<script>

export default {
  name: "DiadocObjectLinks",
  props: [
    "diadoc_object_links",
  ],
  data() {
    return {

    };
  },

  computed: {
    simcards() {
      return this.client_request ? this.client_request.simcards : [];
    },
  },


  methods: {
    title_file(file){
      return `${file.file_name}\n${file.docflow_status_text}\n${this.get_date(file.ts)}`
    },
    short_file_name(file_name) {
      const name = String(file_name || '');

      return name.length > 12
          ? `${name.slice(0, 12)}...`
          : name;
    },
  }
};
</script>
<style lang='scss' scoped>
.diadoc_object_links{
  padding: 10px;
  margin-bottom: 10px;
  &__header{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;

    font-size: 14px;
    line-height: 120%;
    font-weight: bold;
    color: #66615b;
  }
  &__docs{
    display: flex;
    align-items: center;
    justify-content: flex-start;
    .doc{
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      .mdi{
        font-size: 40px;
        line-height: 120%;
      }
      .file_name{
        font-size: 12px;
        line-height: 120%;
        margin-bottom: 0;
      }
    }
  }
}

</style>
